import {
  BodyText,
  DialogContent,
  ModalFooter,
  ModalHeader,
  NextDialog,
} from '@cint/wonderment';
import { ReactNode } from 'react';

interface Props {
  open: boolean;
  linesCount: number;
  publicName: string;
  onClose: () => void;
  onConfirm: () => void;
  isUploading: boolean;
  fileName: string;
  content?: ReactNode;
}

export const ConfirmImportDialog = ({
  open,
  linesCount,
  publicName,
  onClose,
  onConfirm,
  isUploading,
  fileName,
  content,
}: Props) => {
  return (
    <NextDialog open={open}>
      <DialogContent style={{ wordBreak: 'break-word' }}>
        <ModalHeader
          title={`Confirm Import for ${fileName}`}
          isDismissible={false}
        />
        <BodyText>
          You are about to import{' '}
          <BodyText as="span" fontWeight="bold">
            {linesCount}
          </BodyText>{' '}
          rows to{' '}
          <BodyText as="span" fontWeight="bold">
            {publicName}
          </BodyText>
          .
        </BodyText>
        <BodyText as="div">
          {content ?? (
            <>
              Any emails that are already in the system, are on a banned list,
              or belong to a domain in the blocklist will not be imported.
            </>
          )}
        </BodyText>
        <BodyText>Do you want to continue?</BodyText>
        <ModalFooter
          secondaryButtonProps={{ onClick: onClose, text: 'Cancel' }}
          primaryButtonProps={{
            onClick: onConfirm,
            text: 'Continue',
            isDisabled: isUploading,
          }}
        />
      </DialogContent>
    </NextDialog>
  );
};
